module.exports = __webpack_public_path__ + "static/img/pop-kid.e17fbaec.png";